import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { InspectionForm } from 'app/models2/inspections/inspection-form';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import {
  CombosConfiguration,
  ExportDataService,
  FunctionsService,
  HttpService,
  MessageService,
  params,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { Question } from 'app/models2/inspections/question';
import { Equipment } from 'app/models2/maintenance/equipment';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { ModalGenericQuestionComponent } from '../../generic-question/modal-generic-question/modal-generic-question.component';
import { ModalEquipmentFormComponent } from '../modal-equipment-form/modal-equipment-form.component';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { StepperSelectionEvent } from '@angular/cdk/stepper';

@Component({
  selector: 'app-inspection-form-detail',
  templateUrl: './inspection-form-detail.component.html',
  styleUrls: ['./inspection-form-detail.component.scss'],
})
export class InspectionFormDetailComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;
  @Output() completeForm = new EventEmitter<any>();
  @Input() inspectionForm: InspectionForm = null;
  @Output() formChanged = new EventEmitter<boolean>();

  public formIF: FormGroup;
  public formEquipment: FormGroup;
  public formQuestions: FormGroup;
  public editForm: boolean = false;

  public EndpointDictionary = EndpointDictionary;
  public movil;
  public bodyQuestions: Array<Question> = [];
  private size: number = 90;
  public activeButton: boolean = false;
  public equipmentParams: params[] = [{ id: 'formId', value: '0' }];

  public reloadComboPeriodicityType = new EventEmitter<any>();
  public combosConfigPeriodicityType: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: EndpointDictionary.PeriodicityType.PERIODICITY_TYPE_COMBO,
    urlParams: [],
    label: 'Tipo de Periodicidad',
    selected: null,
  };

  reloadTableEquipment = new EventEmitter<any>();
  public dataEquipment: Array<Equipment>;
  configurationEquipment: TableConfiguration = {
    add: true,
    addPer: true,
    delete: true,
    selectable: true,
    primaryKey: 'id',
  };
  public columnsEquiment: TableColumns<Equipment>[] = [
    {
      ID: 'code',
      label: 'Codigo',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'brand',
      label: 'Marca',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'userName',
      label: 'Responsable',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
  ];

  constructor(
    private http: HttpService,
    private formBuilder: FormBuilder,
    private message: MessageService,
    private exportService: ExportDataService,
    public dialog: MatDialog,
    public deleteItem: DeleteGenericService,
    private functionEter: FunctionsService
  ) {
    (this.formIF = this.formBuilder.group({
      name: '',
      version: '',
      code: '',
      dateFormat: '',
      periodicityTypeId: [null, Validators.required],
      periodicityValue: [1, Validators.required],
      description: '',
    })),
      (this.formEquipment = this.formBuilder.group({})),
      (this.formQuestions = this.formBuilder.group({}));
  }

  ngOnInit(): void {
    this.movil = screen.width > 600 ? false : true;
    if (this.inspectionForm) {
      this.activeButton = true;
      this.startFields();
    }
    if (this.inspectionForm == null) {
      this.init();
    }
  }

  async init() {
    this.message.openLoading('Cargando', 'Inicializando formulario');
    const currentDate = new Date();
    const code = await this.http.getDataBody(
      EndpointDictionary.InspectionForm.GET_CODE
    );
    this.formIF.controls.dateFormat.setValue(currentDate.toISOString());
    this.formIF.controls.version.setValue('001');
    this.formIF.controls.code.setValue(code);
    this.message.closeLoading();
  }

  async startFields() {
    this.message.openLoading('Cargando', 'Cargando preguntas');
    this.equipmentParams = [{ id: 'formId', value: this.inspectionForm.id }];

    for (let controls of Object.keys(this.formIF.controls)) {
      if (this.inspectionForm[controls]) {
        this.formIF.controls[controls].setValue(this.inspectionForm[controls]);
      }
    }

    let date = this.functionEter.dateIso(this.inspectionForm.dateFormat);
    this.formIF.controls.dateFormat.setValue(`${date}T08:00:00.000Z`);

    let res: Array<Question> = await this.http.getDataBody(
      `${EndpointDictionary.PreopQuestion.PREOP_BY_FORM}/${this.inspectionForm.id}`
    );

    this.bodyQuestions = res;
    this.message.closeLoading();
  }

  addQuestions($event) {
    this.dialog
      .open(ModalGenericQuestionComponent, {
        width: `${this.size}%`,
        height: `${this.size}%`,
        data: {
          action: 'add',
          body: this.inspectionForm,
        },
      })
      .afterClosed()
      .subscribe(async (questions: Question[]) => {
        this.message.openLoading('Cargando', 'Guardando preguntas');
        if (questions) {
          const newQuestions = questions.filter(
            (newQuestion) =>
              !this.bodyQuestions.some(
                (existingQuestion) => existingQuestion.id === newQuestion.id
              )
          );
          this.bodyQuestions = [...newQuestions, ...this.bodyQuestions];
        }
        this.message.closeLoading();
      });
  }

  async deleteQuestion($event: Question) {
    this.message.openLoading('Cargando', 'Eliminando pregunta');
    let res = await this.deleteItem.deleteD(
      [$event],
      EndpointDictionary.QuestionInspectionForm.CRUD_QUESTION_FORM_DATA,
      'questionIdByForm',
      'Pregunta'
    );
    if (res) {
      const key = this.bodyQuestions[0]?.id ? 'id' : 'questionId';
      this.bodyQuestions = this.bodyQuestions.filter(
        (q) => q[key] !== $event[key]
      );
    }
    this.message.closeLoading();
  }

  getFormAccordingToVersion($event: PointerEvent) {
    let body = this.bodyQuestions.map((x) => {
      return {
        question: x.question,
        responseType: x.responses.toString().replace(/,/g, ', '),
      };
    });
    let headerFileXlsm: Array<params> = [
      { id: 'question', value: 'Pregunta' },
      { id: 'responseType', value: 'Tipo respuesta' },
      { id: null, value: 'versión formato: ' + this.inspectionForm.version },
      { id: null, value: 'código formato: ' + this.inspectionForm.code },
      {
        id: null,
        value: 'fecha del formato: ' + this.inspectionForm.dateFormat,
      },
    ];
    this.exportService.generateToXlsx(
      'Formato inspección',
      headerFileXlsm,
      'Formato inspección',
      body,
      null,
      null,
      null
    );
  }

  async saveFormIF(
    inspectionForm?: InspectionForm,
    advanceStep: boolean = true
  ) {
    this.message.openLoading('Cargando', 'Guardando formulario');
    inspectionForm = await this.getIFFromForm();
    if (this.inspectionForm == null) {
      let res: GenericResponse = await this.http.postDataBody(
        `${EndpointDictionary.InspectionForm.CRUD_INSPECTION_FORM_DATA}`,
        inspectionForm
      );
      if (res) {
        // this.inspectionForm = {} as InspectionForm;
        this.inspectionForm = inspectionForm;
        this.inspectionForm.id = res.insertId;
      }
    } else {
      if (this.editForm) {
        inspectionForm.id = this.inspectionForm.id;
        await this.http.putDataBody(
          `${EndpointDictionary.InspectionForm.CRUD_INSPECTION_FORM_DATA}`,
          inspectionForm
        );
      }
    }
    this.message.closeLoading();
    this.equipmentParams = [{ id: 'formId', value: this.inspectionForm.id }];
    this.reloadTableEquipment.emit();
    if (advanceStep) {
      setTimeout(() => {
        this.stepper.next();
      }, 500);
    }
  }

  async getIFFromForm(): Promise<InspectionForm> {
    return {
      name: this.formIF.controls.name.value,
      version: this.formIF.controls.version.value,
      code: this.formIF.controls.code.value,
      dateFormat: this.functionEter.dateForm(
        this.formIF.controls.dateFormat.value
      ),
      periodicityTypeId: this.formIF.controls.periodicityTypeId.value,
      periodicityValue: this.formIF.controls.periodicityValue.value,
      description: this.formIF.controls.description.value,
    };
  }

  errorMessage() {
    this.message.Error('Error', 'Complete los campos');
  }

  addEquipments($event: string) {
    this.dialog
      .open(ModalEquipmentFormComponent, {
        width: `${this.size}%`,
        height: `${this.size}%`,
        data: {
          action: 'add',
          body: this.inspectionForm,
        },
      })
      .afterClosed()
      .subscribe(() => {
        this.reloadTableEquipment.emit();
      });
  }

  finalizar() {
    setTimeout(() => {
      this.completeForm.emit();
    }, 500);
  }

  deleteEquipment($event: Equipment[]) {
    this.deleteItem
      .deleteD(
        $event,
        EndpointDictionary.EquipmentInspectionForm
          .CRUD_EQUIPMENT_INSPECTION_FORM_DATA,
        'equipmentIdByForm',
        'Equipo',
        'Equipos'
      )
      .then(() => {
        this.reloadTableEquipment.emit();
      });
  }

  onInputChange() {
    const initialValues = this.inspectionForm ? { ...this.inspectionForm } : {};
    const currentValues = this.formIF.getRawValue();

    this.editForm = Object.keys(currentValues).some(
      (key) => currentValues[key] !== initialValues[key]
    );

    this.formChanged.emit(this.editForm);
  }

  onStepChange(event: StepperSelectionEvent): void {
    const previousIndex = event.previouslySelectedIndex;
    const selectedIndex = event.selectedIndex;

    if (previousIndex === 0 && (selectedIndex === 1 || selectedIndex === 2)) {
      this.saveFormIF(undefined, false);
    }
  }
}
